// 导入自己需要的组件
import {
    Form,
    Input,
    Select,
    Button,
    Card,
    message,
    Layout,
    Menu,
    Icon,
    Row,
    Breadcrumb,
    Table,
    Col,
    List,
    Modal,
    Tag,
    Upload,
    Pagination,
    Spin,
    Tooltip,
    Popconfirm,
    Tabs,
    Affix,
    Transfer,
    Checkbox,
    DatePicker,
    TimePicker,
    LocaleProvider,
    Radio,
    Badge,
    Switch
} from 'ant-design-vue';
const ant = {
    install: function (Vue) {
        Vue.use(Form);
        Vue.use(Input);
        Vue.use(Select);
        Vue.use(Button);
        Vue.use(Card);
        Vue.use(Layout);
        Vue.use(Menu);
        Vue.use(Icon);
        Vue.use(Row);
        Vue.use(Col);
        Vue.use(Breadcrumb);
        Vue.use(Table);
        Vue.use(List);
        Vue.use(Modal);
        Vue.use(Tag);
        Vue.use(Upload);
        Vue.use(Pagination);
        Vue.use(Spin);
        Vue.use(Tooltip);
        Vue.use(Popconfirm);
        Vue.use(Tabs);
        Vue.use(Affix);
        Vue.use(Transfer);
        Vue.use(Checkbox);
        Vue.use(DatePicker);
        Vue.use(TimePicker);
        Vue.use(LocaleProvider);
        Vue.use(Radio);
        Vue.use(Badge);
        Vue.use(Switch);
        Vue.prototype.$message = message;
    }
}
export default ant;
